module.exports = __webpack_public_path__ + "img/nav-sljm.09551814.png";